module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Reset password',
        resetPasswordMessage: 'To have your password reset, enter your email address below. We will then send an email containing a link to reset your password.',
        emailLabel: 'Email',
        sendEmailButton: 'Send Email',
        stillHavingTroublesMsg: 'Still having trouble?',
        unableResetPasswordMessage: 'If you’re unable to reset your password, please call Customer Service at',
        sephoraPhoneNumber: '1-877-SEPHORA',
        phoneNumberTTY: '(1-877-737-4672) | TTY',
        phoneNumber: '1-888-866-9845',
        forAssistanceMessage: 'for assistance.',
        resetPassword: 'Reset Password',
        confirmationMessage: `We have sent an email to ${vars[0]}. Please check your inbox and click on the link to reset your password.`
    };

    return resources[label];
};
